// extracted by mini-css-extract-plugin
module.exports = {"activitesMobile":"SpaMobile_activitesMobile__13exB","activitesMobile__cards":"SpaMobile_activitesMobile__cards__nPouh","SpaVisuals":"SpaMobile_SpaVisuals__2fE5X"};